import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=2e4a1b42"
import script from "@/js/searchResult.ts?vue&type=script&lang=ts&external"
export * from "@/js/searchResult.ts?vue&type=script&lang=ts&external"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=2e4a1b42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports